<template>
  <div>
    <v-dialog scrollable max-width="1300px" v-model="showDialog">
      <v-card>
        <v-card-title>
          <h4>¿confirmar macheo?</h4>
        </v-card-title>

        <v-card-text class="black--text">
          <v-layout v-if="obraSgsLocal">
            <v-flex xs6 sm6 md6>
              <v-flex sx12 md12> SGS <b>{{obraSgsLocal.codWorkSq}}</b><v-divider></v-divider> </v-flex>

              <v-flex sx12 md12>
                <div class="text-left h6">
                  {{ obraSgsLocal.title }}
                </div>
              </v-flex>

              <v-flex xs12 md12>
                <div
                  class="text-left"
                  v-for="par in obraSgsLocal.participaciones"
                  :key="par.autor.ipName"
                >
                  {{ par.autor.ipComplete }}
                  {{ par.porcentPer }}%
                </div>
              </v-flex>
            </v-flex>
            <v-flex xs6 sm6 md6 v-if="obraMacheoLocal">
              <v-flex sx12 md12> MACHEO<v-divider></v-divider> </v-flex>

              <v-flex xs md12>
                <div class="text-left h6">{{ obraMacheoLocal.nombreObra }}</div>
              </v-flex>

              <v-flex xs md12>
                <div v-if="obraMacheoLocal.autoresSplit">
                  <div
                    class="text-left"
                    v-for="(autor, index) in obraMacheoLocal.autoresSplit"
                    :key="`autor-${index}`"
                  >
                    {{ autor }}
                  </div>
                </div>
                <div v-else>
                  <div
                    class="text-left"
                    v-for="(artista, index) in obraMacheoLocal.artistasSplit" 
                    :key="`artista-${index}`"
                  >
                    {{ artista }} (artista)
                  </div>
                </div>
              </v-flex>
            </v-flex>
          </v-layout>
          <v-form ref="form">
            <v-text-field
              type="text"
              label="Observacion"
              v-model="observacion"
              autofocus
            />
          </v-form>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="info" @click="volver">Volver</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="warning" @click="confirmar('macheado')">MACHEAR NAC</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="warning" @click="confirmar('Publicidad')">PUBLICIDAD NAC</v-btn>
          <v-spacer></v-spacer>
          <!-- <v-btn color="warning" @click="confirmar('noCorresponde')"
            >No corresponde</v-btn -->
          
          <!-- <v-btn color="warning" @click="confirmar('ONI')">ONI</v-btn> -->
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>

      <div v-if="loading" class="text-center mt-5">
        <img src="img/logo_cargando.gif" alt="apa" />
        <h1 class="title">Cargando . . .</h1>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: ["obraSgs", "obraMacheo", "showDialog"],
  data() {
    return {
      loading: false,
      obraSgsLocal: null,
      obraMacheoLocal: null,
      observacion: "",
      rules: {
        required: (value) => !!value || "Requerido.",
        counter: (value) => value.length <= 1000 || "Maximo 100 caracteres",
      },
      validForm: false,
    };
  },
  mounted() {
    this.retrieveSGS();
  },
  methods: {
    retrieveSGS() {
      this.obraSgsLocal = this.obraSgs;

      let autores =  this.obraMacheo.autores ? this.obraMacheo.autores.split(",") : null;
      let artistas = this.obraMacheo.artistas ? this.obraMacheo.artistas.split(",") : null;
      this.obraMacheoLocal = { ...this.obraMacheo, autoresSplit: autores, artistasSplit: artistas };
      console.log(this.obraMacheoLocal)
      /*convertirmos en filas los autores */

      this.loading = true;
      axios
        .get("/sgs/obra/" + this.obraSgsLocal.codWorkSq + "/participaciones")
        .then((response) => {
          this.loading = false;
          this.obraSgsLocal.participaciones = response.data;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);
        });
    },
    volver() {
      this.$emit("cancelar");
    },
    confirmar(tipo) {
      this.$emit("confirmar", {
        codWorkSq: this.obraSgsLocal.codWorkSq,
        id: this.obraMacheoLocal.id,
        observacion: this.observacion,
        tipo: tipo,
      });
    },

    // axios
    //   .post(`/persona/${this.id}/actualizarCedula/${this.nuevaCedula}`)
    //   .then(response => {
    //     console.log(response);
    //     // this.$emit('nuevaCedula', {id: this.id, nuevaCedula: this.nuevaCedula})
    //     this.close();
    //   })
    //   .catch(err => {
    //     this.loading = false;
    //     this.nuevaCedula = this.cedula;
    //     console.log(err);
    //     this.errorMessage = "Error en la consulta";
    //   });
  },
  watch: {
    obraSgs: function () {
      this.retrieveSGS();
    },
  },
};
</script>
